var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c("style",{tag:"component",attrs:{"type":"text/css","media":"print"}},[_vm._v(" @media print {body {zoom: 100%;}} ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }